export default __webpack_public_path__ + "static/media/btp-1-rMIN.0e973353.avif";